import { Directive, ElementRef, Renderer2, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportService } from '../services/viewport.service';

@Directive({
	selector: '[appAutoHeight]',
	standalone: true
})
export class AutoHeightDirective implements OnInit, OnDestroy {
	private viewportSub!: Subscription;
	@Input() fullHeight: boolean = false;

	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		private viewportService: ViewportService
	) { }

	ngOnInit() {
		this.viewportSub = this.viewportService.getViewportHeight().subscribe(height => {
			this.renderer.setStyle(this.el.nativeElement, 'height', `${this.fullHeight ? height: height-80}px`);
		});
	}

	ngOnDestroy() {
		this.viewportSub?.unsubscribe();
	}
}
